"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8866],{

/***/ 1438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useIsDesktop; },
/* harmony export */   "Hi": function() { return /* binding */ Desktop; },
/* harmony export */   "Y9": function() { return /* binding */ LargeScreen; },
/* harmony export */   "_": function() { return /* binding */ MediumScreen; },
/* harmony export */   "ij": function() { return /* binding */ Mobile; }
/* harmony export */ });
/* unused harmony exports useCustomQuery, IEMediaQuery, EdgeMediaQuery */
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63457);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useCustomQuery = function useCustomQuery(minWidth) {
  return _useMediaQuery("(min-width:".concat(minWidth, "px)"));
};
var useIsDesktop = function useIsDesktop() {
  return (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (theme) {
    return theme.breakpoints.up("md");
  });
};
var Mobile = function Mobile(_ref) {
  var children = _ref.children,
      _ref$aboveTheFold = _ref.aboveTheFold,
      aboveTheFold = _ref$aboveTheFold === void 0 ? false : _ref$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    mdUp: true,
    children: children
  });
};
var Desktop = function Desktop(_ref2) {
  var children = _ref2.children,
      _ref2$aboveTheFold = _ref2.aboveTheFold,
      aboveTheFold = _ref2$aboveTheFold === void 0 ? false : _ref2$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    smDown: true,
    children: children
  });
};
var MediumScreen = function MediumScreen(_ref3) {
  var children = _ref3.children,
      _ref3$aboveTheFold = _ref3.aboveTheFold,
      aboveTheFold = _ref3$aboveTheFold === void 0 ? false : _ref3$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    only: ["xs", "sm", "xl"],
    children: children
  });
};
var LargeScreen = function LargeScreen(_ref4) {
  var children = _ref4.children,
      _ref4$aboveTheFold = _ref4.aboveTheFold,
      aboveTheFold = _ref4$aboveTheFold === void 0 ? false : _ref4$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    lgDown: true,
    children: children
  });
};
var IEMediaQuery = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)";
var EdgeMediaQuery = "@supports (-ms-ime-align:auto)";

/***/ }),

/***/ 92208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(282);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var StyledButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "GenericButton__StyledButtonContainer",
  componentId: "sc-r0056q-0"
})(["width:", ";", " ", " height:48px;", "{width:", ";", "}display:flex;justify-content:center;align-items:center;border-radius:8px;padding:8px 16px;font-family:NarkisBlock;font-size:24px;color:var(--Black,var(--Primary-Black,#000));cursor:pointer;", " ", " ", " ", ""], function (p) {
  return p !== null && p !== void 0 && p.$width ? "".concat(p === null || p === void 0 ? void 0 : p.$width, "px") : "328px";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$fullWidth) && "width: 100%;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p !== null && p !== void 0 && p.$mobileWidth ? "".concat(p === null || p === void 0 ? void 0 : p.$mobileWidth, "px") : "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "filled" && !(p !== null && p !== void 0 && p.$disabled) && "\n      background: var(--Yellow, #ffbc0d);\n\n      &:hover {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n        background: var(--Yellow, #ffbc0d);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: #F5B511;\n      }\n    ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "outlined" && !(p !== null && p !== void 0 && p.$disabled) && "\n      border: 2px solid var(--Yellow, #FFBC0D);\n      background: var(--White, #FFF);\n\n\n      &:hover {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n        background: var(--White, #FFF);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: rgba(247, 247, 247, 0.50);\n      }\n  ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$disabled) && "\n      background: var(--Light-Grey, #F7F7F7);\n      color: rgba(45, 45, 45, 0.72);\n    ";
}, function (p) {
  return p.isdisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  }\n  ";
});
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "GenericButton__StyledIcon",
  componentId: "sc-r0056q-1"
})([""]);

var GenericButton = function GenericButton(_ref) {
  var btnType = _ref.btnType,
      width = _ref.width,
      mobileWidth = _ref.mobileWidth,
      icon = _ref.icon,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      buttonHref = _ref.buttonHref,
      isdisabled = _ref.isdisabled;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButtonContainer, {
    $width: width,
    $mobileWidth: mobileWidth,
    $btnType: btnType,
    $disabled: disabled,
    $fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    type: type,
    isdisabled: isdisabled,
    className: className,
    href: buttonHref,
    children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: icon
    }), children, endIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: endIcon
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GenericButton);

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 85738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].coffeeBrown */ .Z.coffeeBrown : _ref$color,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var w = 24;
  var h = 25;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
      clipPath: "url(#a)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: color,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M17.781 6.266a.75.75 0 0 1 0 1.062l-10.5 10.5a.751.751 0 0 1-1.062-1.062l10.5-10.5a.75.75 0 0 1 1.062 0Z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M6.22 6.266a.75.75 0 0 0 0 1.062l10.5 10.5a.75.75 0 0 0 1.061-1.062l-10.5-10.5a.75.75 0 0 0-1.062 0Z"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
          fill: "#fff",
          transform: "translate(0 .047)",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 23357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PurchasePage_Calendar; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/he/index.js + 5 modules
var he = __webpack_require__(94433);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/CalendarInputIcon.tsx




var SvgComponent = function SvgComponent(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23.167",
    height: "22.627",
    viewBox: "0 0 23.167 22.627",
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-name": "calendar icon",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2612",
        d: "M7.49 8.945a1.3 1.3 0 1 1-1.3-1.3 1.3 1.3 0 0 1 1.3 1.3z",
        transform: "translate(-.009 3.717)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2613",
        d: "M6.2 12.24a1.3 1.3 0 1 0-1.3-1.3 1.3 1.3 0 0 0 1.3 1.3z",
        transform: "translate(-.009 6.035)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2614",
        d: "M12.49 8.945a1.3 1.3 0 1 1-1.3-1.3 1.3 1.3 0 0 1 1.3 1.3z",
        transform: "translate(5.785 3.717)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2615",
        d: "M11.2 12.24a1.3 1.3 0 1 0-1.3-1.3 1.3 1.3 0 0 0 1.3 1.3z",
        transform: "translate(5.785 6.035)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2616",
        d: "M9.99 8.945a1.3 1.3 0 1 1-1.3-1.3 1.3 1.3 0 0 1 1.3 1.3z",
        transform: "translate(2.888 3.717)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2617",
        d: "M8.7 12.24a1.3 1.3 0 1 0-1.3-1.3 1.3 1.3 0 0 0 1.3 1.3z",
        transform: "translate(2.888 6.035)",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2618",
        d: "M7.607 4.119H7.5a4.749 4.749 0 0 0-4.75 4.749v11.01a4.749 4.749 0 0 0 4.75 4.749h13.167a4.749 4.749 0 0 0 4.749-4.749V8.868a4.749 4.749 0 0 0-4.749-4.749h-.108v-.54a1.079 1.079 0 0 0-2.159 0v.54H9.766v-.54a1.079 1.079 0 0 0-2.159 0zM19.48 7.9a1.079 1.079 0 0 1-1.08-1.083v-.54H9.766v.54a1.079 1.079 0 0 1-2.159 0v-.54H7.5a2.59 2.59 0 0 0-2.59 2.59v.648h18.348v-.647a2.591 2.591 0 0 0-2.59-2.59h-.108v.54A1.079 1.079 0 0 1 19.48 7.9zM4.909 11.675h18.349v8.2a2.591 2.591 0 0 1-2.59 2.59H7.5a2.591 2.591 0 0 1-2.59-2.59z",
        transform: "translate(-2.5 -2.25)",
        fillRule: "evenodd",
        fill: "#264f36",
        stroke: "#f7f7f7",
        strokeWidth: ".5px "
      })]
    })
  });
};

/* harmony default export */ var CalendarInputIcon = (SvgComponent);
// EXTERNAL MODULE: ./components/Icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(85738);
;// CONCATENATED MODULE: ./components/PurchasePage/Calendar.tsx













var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledWrapper",
  componentId: "sc-kja14a-0"
})(["margin-bottom:20px;", "{margin-right:0px;margin-bottom:0px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledPickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledPickerWrapper",
  componentId: "sc-kja14a-1"
})(["display:flex;width:300px;position:relative;.react-datepicker__navigation-icon--next,.react-datepicker__navigation-icon--previous{transform:rotate(180deg);top:0px;}.react-datepicker__navigation-icon--next{left:2px;}.react-datepicker__navigation-icon--previous{right:2px;}", "{width:100%;}.react-datepicker-wrapper{width:300px;position:relative;", "{width:100%;}}.react-datepicker__input-container{display:flex;}.react-datepicker__month-container{float:right;}.react-datepicker__month{padding-right:5px;", "{margin:0px;}}.react-datepicker__header{height:112px;background:#fff;border-bottom:1px solid #e3e3e3;border-top-left-radius:15px;border-top-right-radius:15px;padding-top:22px;padding-bottom:22px;}.react-datepicker__time-container{padding-right:10px;padding-left:10px;border-left:none;display:flex;align-items:center;flex-direction:column;", "{margin-right:8px;width:75px;}.react-datepicker__time{border-radius:15px;}}.react-datepicker-popper{z-index:10;inset:0px 0px 0px 0px !important;transform:translate(0px,30px) !important;}.react-datepicker{border-radius:15px;box-shadow:0 10px 35px 0 rgba(0,0,0,0.15);width:", ";border:none;height:452px;", "{width:auto;min-width:260px;padding-right:0px;}}.react-datepicker__current-month{text-align:center;font-family:\"NarkisBlock\";font-size:24px;font-weight:500;}.react-datepicker__day--selected{background-color:#264f36;border-radius:50%;color:#fff;font-weight:100;outline:none;}.react-datepicker__triangle{display:none;}input{width:300px;height:50px;border:none;padding-left:10px;font-size:20px;font-family:Speedee,NarkisBlock;padding-right:45px;color:#000;font-size:20px;", ";text-align:right;", "{font-size:16px;width:100%;}border-radius:8px;border:1px solid #e5e5e5;&:hover{border:1px solid var(--Grey,#757575);}&:focus-within{border:1px solid var(--Yellow,#ffbc0d);outline:none;}}.react-datepicker__day-name,.react-datepicker-time__header{font-size:20px;font-family:NarkisBlock;}.react-datepicker__day-names{margin-top:12px;}.react-datepicker__time-list-item{font-size:20px;font-family:\"NarkisBlock-Thin\";color:#757575;}.react-datepicker__day{font-size:20px;font-family:\"NarkisBlock-Thin\";", "{}}.react-datepicker__day-name{", "{}}svg{position:absolute;right:10px;top:12px;cursor:pointer;}ul{height:245px !important;&::-webkit-scrollbar{display:none;}}.react-datepicker__header--time{display:flex;align-items:end;justify-content:center;padding:0px;padding-bottom:10px;", "{width:85px;}}.react-datepicker__navigation--next{background-color:#f7f7f7;border-radius:50%;right:", ";top:22px;width:31px;height:31px;", "{right:", ";}span{&::before{left:-3px;border-color:#000;border-width:1px 1px 0 0;top:8px;height:7px;width:7px;}}}.react-datepicker__navigation--previous{background-color:#f7f7f7;border-radius:50%;left:", ";top:22px;width:31px;height:31px;", "{left:", ";}span{&::before{right:-3px;border-color:#000;border-width:1px 1px 0 0;top:8px;height:7px;width:7px;}}}.react-datepicker__time-list-item--selected{background-color:transparent !important;color:#264f36 !important;border:none;outline:none;}.react-datepicker__time-list-item--disabled{border:none;outline:none;}.react-datepicker__week{padding-top:5px;}.react-datepicker__day--keyboard-selected{background:none;color:#000;}.react-datepicker__day--today{font-weight:normal;background-color:#f7f7f7;border-radius:50%;color:#000000;}.react-datepicker__day--selected.react-datepicker__day--today{background-color:#264f36;color:#fff;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$type === "endTime" ? "260px" : "325px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return !p.$default && "direction: ltr";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$type === "endTime" ? "225px" : "275px";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$type === "endTime" ? "225px" : "265px";
}, function (p) {
  return p.$type === "endTime" ? "40px" : "70px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$type === "endTime" ? "40px" : "65px";
});
var StyledSvgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledSvgWrapper",
  componentId: "sc-kja14a-2"
})(["background-color:#f7f7f7;border-radius:50%;position:absolute;top:22px;right:15px;z-index:10;width:31px;height:31px;display:flex;align-items:center;justify-content:center;svg{position:relative;right:0;top:0;width:20px;height:20px;}", "{right:", ";}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$type === "endTime" ? "15px" : " calc((100% - 310px) / 2);";
});
var StyledButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledButtonWrapper",
  componentId: "sc-kja14a-3"
})(["height:50px;position:absolute;z-index:10;top:380px;padding-right:13px;padding-left:13px;width:100%;", "{padding:0 15px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var CalendarButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__CalendarButtons",
  componentId: "sc-kja14a-4"
})(["width:230px;height:30px;position:absolute;top:340px;z-index:10;display:flex;justify-content:space-between;padding-left:13px;padding-right:13px;font-size:20px;font-family:\"NarkisBlock-Thin\";", "{right:", ";width:240px;padding-left:15px;padding-right:15px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$type === "endTime" ? "0px" : "calc((100% - 320px) / 2)";
});
var StyledClearButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledClearButton",
  componentId: "sc-kja14a-5"
})(["color:#264f36;cursor:pointer;"]);
var StyledTodayButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBase/* default */.Z).withConfig({
  displayName: "Calendar__StyledTodayButton",
  componentId: "sc-kja14a-6"
})(["color:#264f36;cursor:pointer;font-size:20px;font-family:\"NarkisBlock-Thin\";"]);
var StyledCalendarInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendar__StyledCalendarInput",
  componentId: "sc-kja14a-7"
})(["z-index:1;pointer-events:", ";"], function (p) {
  return p.$disabled ? "none" : "auto";
});

var Calendar = function Calendar(_ref) {
  var date = _ref.date,
      setDate = _ref.setDate,
      type = _ref.type,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? new Date() : _ref$minDate,
      filterDate = _ref.filterDate,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$handleTimeChange = _ref.handleTimeChange,
      handleTimeChange = _ref$handleTimeChange === void 0 ? function () {} : _ref$handleTimeChange,
      _ref$setEndTime = _ref.setEndTime,
      setEndTime = _ref$setEndTime === void 0 ? function () {} : _ref$setEndTime;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var defaultData = "בחרו תאריך";

  var _useState2 = (0,react.useState)(null),
      minTime = _useState2[0],
      setMinTime = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      maxTime = _useState3[0],
      setMaxTime = _useState3[1];

  var isToday = (0,react.useMemo)(function () {
    return moment_default()().format("L") === moment_default()(date).format("L");
  }, [date]);
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var ref = (0,react.useRef)(null);
  (0,react_datepicker_min.setDefaultLocale)("he_IL");
  (0,react_datepicker_min.registerLocale)("he_IL", he/* default */.Z);
  (0,react.useEffect)(function () {
    if (date) if (isToday) {
      setMinMaxDate();
    }
  }, [date]);

  var setMinMaxDate = function setMinMaxDate() {
    setMinTime(new Date());
    var date = new Date();
    date.setHours(23);
    date.setMinutes(45);
    setMaxTime(date);
  };

  var onChange = function onChange(date) {
    if (new Date(date) >= new Date()) {
      handleTimeChange();
      setDate(date);
    }
  };

  var checkCurrentDay = function checkCurrentDay(date) {
    if (moment_default()().format("L") === moment_default()(date).format("L") && date < new Date()) {
      setTodayDate();
    }
  };

  var setTodayDate = function setTodayDate() {
    var date = new Date();
    var coeff = 15 - date.getMinutes() % 15;
    var rounded = moment_default()().add(coeff, "minutes");
    date.setHours(rounded.hours());
    date.setMinutes(rounded.minutes());
    setDate(date);
    if (type === "startTime") setEndTime(null);
  };

  var handleCalendarClose = function handleCalendarClose() {
    setIsOpen(false);
  };

  var handleCalendarOpen = function handleCalendarOpen() {
    setIsOpen(true);
    setMinTime(new Date());
    setMinMaxDate();
  };

  var twoWeeksFromNow = new Date();
  twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14);

  var isButtonDisabled = function isButtonDisabled() {
    var currentDate = new Date();
    var thresholdHour = 23;
    var thresholdMinute = 45;
    if (currentDate.getHours() === thresholdHour && currentDate.getMinutes() > thresholdMinute) return true;
    return false;
  };

  var disableKeyboard = function disableKeyboard(e) {
    if (!isDesktop) e.target.readOnly = true;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPickerWrapper, {
      $default: date,
      $type: type,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledCalendarInput, {
        $disabled: disabled,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarInputIcon, {
          onClick: handleCalendarOpen
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((react_datepicker_min_default()), {
        locale: "he_IL",
        className: "form-control",
        selected: date ? date : "",
        onChange: onChange,
        value: date ? date : defaultData,
        name: "selectDate",
        showTimeSelect: type !== "endTime",
        timeIntervals: 15,
        timeFormat: "HH:mm",
        timeCaption: "\u05E9\u05E2\u05D4",
        dateFormat: type === "endTime" ? "dd/MM/yy" : "dd/MM/yy, HH:mm",
        maxDate: type === "schedule" ? twoWeeksFromNow : null,
        minDate: minDate,
        minTime: (isToday || !date) && minTime,
        maxTime: (isToday || !date) && maxTime,
        ref: ref,
        openToDate: date,
        onCalendarClose: handleCalendarClose,
        onCalendarOpen: handleCalendarOpen,
        open: isOpen,
        onSelect: checkCurrentDay,
        onKeyDown: function onKeyDown(e) {
          !isDesktop && e.preventDefault();
        },
        onInputClick: function onInputClick() {
          return setIsOpen(true);
        },
        filterDate: filterDate,
        disabled: disabled,
        shouldCloseOnSelect: false,
        readOnly: isDesktop ? false : true,
        onFocus: function onFocus(e) {
          return disableKeyboard(e);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSvgWrapper, {
          onClick: handleCalendarClose,
          $type: type,
          children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonWrapper, {
          $type: type,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericButton/* default */.Z, {
            disabled: date ? false : true,
            onClick: function onClick() {
              return handleCalendarClose();
            },
            btnType: "filled",
            fullWidth: true,
            children: "\u05D1\u05D7\u05D9\u05E8\u05D4"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalendarButtons, {
          $type: type,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledClearButton, {
            onClick: function onClick(event) {
              setDate(null);
              event.preventDefault();
            },
            children: "\u05E0\u05D9\u05E7\u05D5\u05D9"
          }), type !== "endTime" && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTodayButton, {
            onClick: setTodayDate,
            disabled: isButtonDisabled(),
            children: "\u05D4\u05D9\u05D5\u05DD"
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var PurchasePage_Calendar = (Calendar);

/***/ }),

/***/ 60166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50253);
/* harmony import */ var components_Balance_GroupCardContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19921);
/* harmony import */ var components_Reusable_Bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26490);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50066);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75741);
/* harmony import */ var _Texts_HeadingText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22368);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "GiftCardScheduler__StyledBox",
  componentId: "sc-83imhj-0"
})(["margin-top:30px;", "{width:690px;margin-top:40px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "GiftCardScheduler__StyledText",
  componentId: "sc-83imhj-1"
})(["text-align:right;line-height:26px;"]);
var StyledButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "GiftCardScheduler__StyledButtonWrapper",
  componentId: "sc-83imhj-2"
})(["margin-top:20px;margin-bottom:20px;", "{button{width:33.333%;", "}}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$groupPurchase) && "width: 50%;";
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "GiftCardScheduler__StyledLabel",
  componentId: "sc-83imhj-3"
})(["cursor:pointer;width:100%;height:100%;:focus{outline:none;}"]);
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "GiftCardScheduler__StyledButton",
  componentId: "sc-83imhj-4"
})(["width:158px;height:55px;background-color:", ";color:", ";display:flex;justify-content:center;align-items:center;font-family:\"NarkisBlock\";font-size:24px;font-weight:bold;", "{width:100%;height:46px;margin-left:10px;line-height:23px;padding:10px;}:hover{border:1px solid ", ";}"], function (p) {
  return p.$isSelected ? "#264f36" : "#f7f7f7";
}, function (p) {
  return p.$isSelected ? "#fff" : "#757575";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, theme_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].darkGreen */ .Z.darkGreen);
var StyledTextItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "GiftCardScheduler__StyledTextItem",
  componentId: "sc-83imhj-5"
})(["", "{width:90px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var GiftCardScheduler = function GiftCardScheduler(_ref) {
  var setScheduleType = _ref.setScheduleType,
      scheduleType = _ref.scheduleType,
      setSchedulerType = _ref.setSchedulerType,
      groupPurchase = _ref.groupPurchase;

  var _useGroupCardContext = (0,components_Balance_GroupCardContext__WEBPACK_IMPORTED_MODULE_0__/* .useGroupCardContext */ .KA)(),
      setScheduleTime = _useGroupCardContext.setScheduleTime;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var isGroupPurchase = router.pathname.includes("groupPurchase");
  var buttons = isGroupPurchase ? [{
    value: "AfterPayment",
    text: "שלחו עכשיו"
  }, {
    value: "Scheduled",
    text: "במועד אחר שאבחר"
  }] : [{
    value: "Allowance",
    text: "דמי כיס"
  }, {
    value: "AfterPayment",
    text: "חד פעמי שלחו עכשיו"
  }, {
    value: "Scheduled",
    text: "חד פעמי במועד שאבחר"
  }];

  var handleButtonClick = function handleButtonClick(code) {
    if (code === "AfterPayment") setScheduleTime("");
    setScheduleType(code);
    setSchedulerType(code);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBox, {
    children: [!isGroupPurchase && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Texts_HeadingText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        text: "איזה גיפטקארד לשלוח?"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledText, {
        children: "\u05D1\u05D7\u05E8\u05D5 \u05D7\u05D3 \u05E4\u05E2\u05DE\u05D9 \u05D0\u05D5 \u05D3\u05DE\u05D9 \u05DB\u05D9\u05E1 \u05E9\u05D9\u05D9\u05E9\u05DC\u05D7\u05D5 \u05E7\u05D1\u05D5\u05E2 \u05DB\u05DC \u05EA\u05E7\u05D5\u05E4\u05EA \u05D6\u05DE\u05DF"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledButtonWrapper, {
      $groupPurchase: groupPurchase,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_Reusable_Bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: "scheduleSelect",
        items: buttons.map(function (amount) {
          return {
            value: amount.value,
            name: amount.text
          };
        }),
        noFocus: true,
        onSelect: function onSelect(code) {
          return handleButtonClick(code);
        },
        gap: 15,
        itemsPerRow: "auto",
        selectedValue: scheduleType,
        customButton: function customButton(radioId, isSelected, item) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledLabel, {
              htmlFor: radioId,
              $activeButton: isSelected,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledButton, {
                $isSelected: isSelected,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledTextItem, {
                  children: item.name
                })
              })
            })
          });
        }
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GiftCardScheduler);

/***/ }),

/***/ 22368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var StyledHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
  component: "h2",
  variant: "h4"
}).withConfig({
  displayName: "HeadingText__StyledHeading",
  componentId: "sc-1o76gmb-0"
})(["text-align:right;line-height:1;font-family:\"NarkisBlock\";", " ", " ", " ", "{margin-right:0;}"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$small) && "font-size: 24px;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$textIndent) && "margin-right: 150px;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$marginBottom) && "margin-bottom: ".concat(p.$marginBottom, "px;");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});

var HeadingText = function HeadingText(_ref) {
  var text = _ref.text,
      tabIndex = _ref.tabIndex,
      small = _ref.small,
      textIndent = _ref.textIndent,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledHeading, {
    tabIndex: tabIndex,
    $small: small,
    $textIndent: textIndent,
    $marginBottom: marginBottom,
    children: text
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HeadingText);

/***/ }),

/***/ 26490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SingleButtonSelection__StyledContainer",
  componentId: "sc-1586vsq-0"
})(["display:flex;flex-wrap:wrap;"]);
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "SingleButtonSelection__StyledButtonWrap",
  componentId: "sc-1586vsq-1"
})(["width:", ";"], function (props) {
  return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "SingleButtonSelection__StyledLabel",
  componentId: "sc-1586vsq-2"
})(["width:100%;height:44px;border:solid 1px transparent;position:relative;display:flex;align-items:center;justify-content:center;border-radius:5px;background-color:#fff;font-size:16px;direction:", ";cursor:pointer;position:relative;", " @media print{display:none;justify-content:flex-start;box-shadow:none;background-image:none !important;span{justify-content:flex-start;}}b{font-size:1.5em;}span{width:100%;height:100%;display:flex;align-items:center;justify-content:center;position:absolute;inset:0;line-height:1;}", ""], function (p) {
  return p.$isBattery ? "ltr" : "rtl";
}, function (p) {
  return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function (p) {
  return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "SingleButtonSelection__StyledRadio",
  componentId: "sc-1586vsq-3"
})(["position:absolute;border:0;margin:-1px;padding:0;border-radius:50%;width:1px;height:1px;opacity:0;:checked + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:focus + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:hover{border:2px solid black;}:focus-visible{border:3px solid ", " !important;}"], StyledLabel, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, StyledLabel, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (p) {
  return p.theme.colors.darkYellow;
});
var SingleButtonSelection = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref5, bgRef) {
  var id = _ref5.id,
      items = _ref5.items,
      onSelect = _ref5.onSelect,
      isBattery = _ref5.isBattery,
      customButton = _ref5.customButton,
      selectedValue = _ref5.selectedValue,
      className = _ref5.className,
      _ref5$itemsPerRow = _ref5.itemsPerRow,
      itemsPerRow = _ref5$itemsPerRow === void 0 ? 2 : _ref5$itemsPerRow,
      _ref5$gap = _ref5.gap,
      gap = _ref5$gap === void 0 ? 10 : _ref5$gap,
      _ref5$allowEmpty = _ref5.allowEmpty,
      allowEmpty = _ref5$allowEmpty === void 0 ? false : _ref5$allowEmpty,
      _ref5$noFocus = _ref5.noFocus,
      noFocus = _ref5$noFocus === void 0 ? false : _ref5$noFocus;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(allowEmpty ? selectedValue : selectedValue || items[0].value),
      selectedButton = _useState[0],
      setSelectedButton = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!items || !items.length || !selectedValue) {
      return;
    }

    setSelectedButton(selectedValue || items[0].value);
  }, [items, selectedValue]);

  var handleChange = function handleChange(value, index) {
    setSelectedButton(value);
    onSelect(value, index);
  };

  return (
    /*#__PURE__*/
    // <RowWithTitle {...{ title, id, headlineComponent }} noPrint={!isBattery}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
      role: "radiogroup",
      "aria-labelledby": id,
      $gap: gap,
      className: className,
      children: items.map(function (item, index) {
        var _item$name;

        var radioId = "radio_".concat(id, "_").concat(item.value);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
          tabIndex: noFocus ? -1 : undefined,
          role: "presentation",
          $itemsPerRow: itemsPerRow,
          $gap: gap,
          "aria-label": item !== null && item !== void 0 && item.ariaLabel ? item === null || item === void 0 ? void 0 : item.ariaLabel : index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
            "aria-label": index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
            ref: index === 0 ? bgRef : null,
            type: "radio",
            name: id,
            value: item.value,
            tabIndex: !noFocus ? -1 : undefined,
            id: radioId,
            checked: item.value === selectedButton // disabled={!color.details.inStock}
            ,
            onChange: function onChange() {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          }), customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
            $isBattery: isBattery,
            htmlFor: radioId,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
              children: [item.secondaryName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                children: [item.secondaryName.toUpperCase(), "\xA0"]
              }), (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toUpperCase()]
            })
          })]
        }, item.value);
      })
    }) // </RowWithTitle>

  );
});
SingleButtonSelection.displayName = "SingleButtonSelection";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(SingleButtonSelection));

/***/ }),

/***/ 64416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ formatGiftCardNumber; },
/* harmony export */   "Sp": function() { return /* binding */ isWebview; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "rB": function() { return /* binding */ shareSocialNetworkLinks; },
/* harmony export */   "rv": function() { return /* binding */ formatPhoneNumberPayment; },
/* harmony export */   "un": function() { return /* binding */ formatPhoneNumber; },
/* harmony export */   "zw": function() { return /* binding */ shareToNavigator; }
/* harmony export */ });
var isNumber = function isNumber(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;

  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }

  return true;
};
var shareToNavigator = function shareToNavigator(text, url) {
  navigator.share({
    title: "Macdonalds giftcard",
    text: "".concat(text),
    url: url || document.location.href
  }).then(function () {
    console.log("Successfully shared");
  })["catch"](function (error) {
    console.error("Something went wrong sharing the blog", error);
  });
};
var shareSocialNetworkLinks = function shareSocialNetworkLinks(text) {
  var arr = {
    whatsapp: {
      mobile: "https://wa.me/?text=".concat(encodeURIComponent(text)),
      desktop: "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(text))
    },
    telegram: {
      mobile: "https://t.me/share/url?url=".concat(encodeURIComponent(text)),
      desktop: "https://t.me/share/url?url=".concat(encodeURIComponent(text))
    }
  };
  return arr;
};
var formatPhoneNumber = function formatPhoneNumber(value) {
  var number = value === null || value === void 0 ? void 0 : value.trim().replace(/[^0-9]/g, "").replace("972", ""); // remove international code

  if (number) {
    if (number.length < 4) return number; // add zero to number if it doesnt start with one

    if (number && number[0] !== "0") number = "0" + number;

    if (number.length === 8) {
      return number.replace(/(\d{2})(\d{6})/, "$1-$2");
    } else if (number.length >= 9) {
      return number.replace(/(\d{3})(\d{6})/, "$1-$2");
    } else {
      return number;
    }
  }

  return "";
};
var formatGiftCardNumber = function formatGiftCardNumber(value) {
  var number = value === null || value === void 0 ? void 0 : value.trim().replace(/[^0-9]/g, "");

  if (number) {
    if (number.length < 4) return number;
    if (number.length < 9) return number.replace(/(\d{4})(\d{1})/, "$1-$2");
    if (number.length < 13) return number.replace(/(\d{4})(\d{4})(\d{1})/, "$1-$2-$3");
    if (number.length < 16) return number.replace(/(\d{4})(\d{4})(\d{4})(\d{1})/, "$1-$2-$3-$4");
    return number.replace(/(\d{3})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  }
};
function isWebview() {
  var webviewPatterns = [/WebView/i];
  var userAgent = window.navigator.userAgent;
  return webviewPatterns.some(function (pattern) {
    return pattern.test(userAgent);
  });
}
var formatPhoneNumberPayment = function formatPhoneNumberPayment(phoneNumber) {
  // Remove any non-numeric characters from the phone number
  if (phoneNumber) {
    var numericPhoneNumber = phoneNumber.replace(/\D/g, ""); // Use regular expressions to add the dashes in the desired format

    var formattedPhoneNumber = numericPhoneNumber.replace(/(\d{3})(\d{4})(\d{3})/, "$1-$2-$3");
    return formattedPhoneNumber;
  }

  return "";
};

/***/ })

}]);